import store from "@/store/index";

class HandlerShipPartTable {


    private static _i18n_translation = {
        
        es: {
            mainEngine: "Motores principales",
            auxiliaryEngine: "Auxiliary engines",
            AuxiliaryEngineEnergySavings: "Tecnologías eléctricas de eficiencia energética innovadoras de los motores auxiliares",
            MainEngineEnergySavings: "Tecnologías mecánicas de eficiencia energética innovadoras de los motores principales",
        },
        
        en:{
            mainEngine: "Main engines",
            auxiliaryEngine: "Motores auxiliares",
            AuxiliaryEngineEnergySavings: "Innovative auxiliary motor electrical energy efficiency technologies",
            MainEngineEnergySavings: "Innovative main engine mechanical energy efficiency technologies",
            
        }
        
        
    }
    
    public static getTranslationText() {
        const state = store.getters.languageState;
        if (state == 'es'){
            return this._i18n_translation.es
            
        }else{
            return this._i18n_translation.en
        }
    }
}

export default HandlerShipPartTable;

